import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { makeStyles } from "@material-ui/styles";
import "date-fns";
import { es } from "date-fns/locale";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface CustomDateFieldProps {
  onChange?: React.ComponentProps<typeof KeyboardDatePicker>["onChange"];
  value?: React.ComponentProps<typeof KeyboardDatePicker>["value"];
}

const langMap: Record<string, any> = {
  "es-ES": es,
};

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: 0,
    },
  },
});

export type DateFieldProps = Omit<
  React.ComponentProps<typeof KeyboardDatePicker>,
  keyof CustomDateFieldProps
> &
  CustomDateFieldProps;

export const DateField = React.forwardRef<HTMLInputElement, DateFieldProps>(
  (props, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const { i18n, t } = useTranslation("common");

    const classes = useStyles();
    return (
      <MuiPickersUtilsProvider
        utils={DateFnsUtils}
        locale={langMap[i18n.language]}
      >
        <KeyboardDatePicker
          cancelLabel={t("cancel")}
          okLabel={t("ok")}
          format="dd/MM/yyyy"
          {...props}
          value={props.value === undefined ? "" : props.value}
          onChange={(newDate) => {
            if (props.onChange) props.onChange(newDate);
            setIsOpen(false);
          }}
          KeyboardButtonProps={{
            onFocus: (e) => {
              setIsOpen(true);
            },
          }}
          onAccept={() => setIsOpen(false)}
          onAbort={() => setIsOpen(false)}
          onClose={() => setIsOpen(false)}
          DialogProps={{
            disableRestoreFocus: true,
            onClose: () => {
              setIsOpen(false);
            },
          }}
          InputProps={{
            onFocus: () => {
              setIsOpen(true);
            },
          }}
          label={
            props.value === undefined ||
            props.value === "" ||
            props.value === null
              ? props.label
              : ""
          }
          open={isOpen}
          inputRef={ref}
          inputVariant="outlined"
          id={`date-${props.name}`}
          className={classes.root + " " + props.className}
        />
      </MuiPickersUtilsProvider>
    );
  }
);
